import { Module } from 'vuex';
import { fetchGetUserInfo, fetchLogout } from '@/apis/account';
import { ILocalStorage, ILocalStorageKey } from '@/utils/local-storage';
interface IState {
  user?:AccountAPI.Response.ILogin;
}
export const userModule:Module<IState, {}> = {
  state: () => ({
    user: undefined,
  }),
  actions: {
    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        // 如果已经存在则直接返回缓存
        if (state.user) {
          resolve(state.user);
          return;
        };
        // 如果不存在，则调用接口获取
        fetchGetUserInfo().then((res) => {
          if (/^2\d/.test(res.status.toString())) {
            const userinfo:AccountAPI.Response.ILogin = {
              user_info: {
                id: res.data.user_id,
                nickname: res.data.nickname,
                avatar_url: res.data.fullname,
                fullname: res.data.fullname,
                sex: res.data.sex,
                birthday: undefined,
                qq: '',
                description: '',
              },
              auth: {
                token: '',
                email: '',
                phone_number: res.data.phone,
                has_password: false,
                is_weak_password: false,
              },
            };
            ILocalStorage.setItem(ILocalStorageKey.USER_ID, res.data.user_id);
            commit('SetUserInfo', userinfo);
            resolve(userinfo);
          } else {
            resolve(undefined);
          }
        }).catch(() => {
          resolve(undefined);
        });
      });
    },
    // 退出登录
    Logout({ commit }) {
      return new Promise((resolve, reject) => {
        fetchLogout().then((res) => {
          ILocalStorage.removeItem(ILocalStorageKey.USER_ID);
          commit('RemoveUserInfo');
          resolve(true);
        }).catch((err) => {
          reject(err);
        });
      });
    },
  },
  mutations: {
    RemoveUserInfo(state) {
      state.user = undefined;
    },
    SetUserInfo(state, userinfo) {
      state.user = userinfo;
    },
  },
  getters: {
    // GetUserInfo(state) {
    //   return state.user;
    // },
  },
};
